var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 0H10.6667C11.4 0 12 0.6 12 1.33333V2L10.6667 3.33333V1.33333H1.33333V10.6667H10.6667V5.33333L12 4V10.6667C12 11.4 11.4 12 10.6667 12H1.33333C0.6 12 0 11.4 0 10.6667V1.33333C0 0.6 0.6 0 1.33333 0Z",
    fill: "#AAAAB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0896 0.580484C12.4259 0.256407 12.9582 0.2562 13.2948 0.580018C13.65 0.921751 13.65 1.49018 13.2949 1.83196L6.19092 8.66919C5.80509 9.04053 5.19521 9.04203 4.80756 8.67259L2.60698 6.57538C2.24707 6.23237 2.24773 5.6579 2.60842 5.31571C2.94414 4.99722 3.47053 4.99764 3.80574 5.31666L5.50087 6.92993L12.0896 0.580484Z",
    fill: "#F0F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/select-all.33d55dc7.svg";
export { ForwardRef as ReactComponent };